



















































import Vue from 'vue'
import {
  carCategoryController,
  carSeasonsController,
  carContractSharedPriceController,
  carContractSharedController,
} from '~/api/RentalCar'
import AppView from '~/components/AppView.vue'
import Autocomplete from '~/components/Autocomplete.vue'
import { TableHeader } from '~/utils/interfaces'
import { ContractSharedPrice } from '~/utils/interfaces/rentalCar'
export default Vue.extend({
  components: { AppView, Autocomplete },
  data() {
    return {
      controller: carContractSharedPriceController,
      headers: [
        {
          text: this.$t('contract'),
          value: 'contract_name',
        },
        {
          text: this.$t('min_days'),
          value: 'min_days',
        },
        {
          text: this.$t('max_days'),
          value: 'max_days',
        },
        {
          text: this.$t('category'),
          value: 'category_name',
        },
        {
          text: this.$t('season'),
          value: 'season_name',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ] as TableHeader<ContractSharedPrice>[],
      defaultCrud: {
        category: '',
        contract: '',
        cost: '',
        max_days: '',
        min_days: '1',
        season: '',
      },
    }
  },
  methods: {
    getCarCategories: carCategoryController.getter,
    getCarContracts: carContractSharedController.getter,
    getCarSeasons: carSeasonsController.getter,
  },
})
